<template>
    <b-carousel
            :arrow="arrow"
            :repeat="arrowBoth"
            :arrow-hover="arrowHover"
            :icon-pack="iconPack"
            :icon-prev="iconPrev"
            :icon-next="iconNext"
            :icon-size="iconSize"
            class="quote">
            <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                <div class="hero">
                    <div class="hero-body">
                        <div class="container">
                            <article class="media">
                                <div class="media-content">
                                    <div class="content">
                                        <strong class="has-text-dark">{{carousel.name}}</strong>
                                        <p class="has-text-dark">"{{carousel.message}}"</p>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </b-carousel-item>
        </b-carousel>
</template>

<script>
export default {
    data: function(){
        return{
            arrow: false,
            arrowBoth: true,
            arrowHover: false,
            iconPack: 'fas',
            iconPrev: 'arrow-left',
            iconNext: 'arrow-right',
            iconSize: '',
            carousels: [
                {name: 'Ralph Wright', message: "Stacy has done so much more than coach me in the gym.  She's helped me work on all aspects of my life that impact my fitness goals.  I now have all the tools I need to live a healthy lifestyle."},
                {name: 'Erica Rands', message: "My life can be described in two time distinct periods: Before Stacy and After Stacy. Before Stacy, I was bored, uninspired, and generally unhappy with my body. After Stacy, I found passions I never knew I had—running, obstacle course races, powerlifting. I became an athlete. I’m the healthiest, happiest and strongest, I have ever been. There’s no going back to the “Before Stacy” version of me ever again!"},
                {name: 'Shanyn Nelson', message: "Stacy is so much more than a \"trainer,\" she is a COACH in the truest sense of the word.  A coach is someone dedicated to their chosen sport, someone who takes a personal interest in your success.  In Stacy's case, she puts her whole self into seeing each and every client succeed at the highest level possible.  She tells it like it is when necessary, and will be your biggest cheerleader when you need it - I'm proud to call her my coach and my friend."},
                {name: 'Andy Stanton', message: "Stacy is dynamic trainer with an impressive knowledge base. She never ceases to amaze me with the depth of knowledge she has on any and every topic. She has helped me with various fitness and dietary goals. Her creativity always keeps things interesting and motivating. Training with Stacy will never be boring. If I were to describe Stacy in the fewest words possible it would be “positive energy” because she exudes it every moment of the day."},
                {name: 'Jeanine Richardson', message: "Stacy has been a phenomenal coach for me. She was highly recommended by a friend of mine in the fitness community. I am so glad our paths finally crossed. She has helped me reach and exceed my fitness, bodyfat, and self-image goals. Stacy takes a comprehensive approach and ensures that her clients are healthy and fit."}
            ]
        }
    }
}
</script>

<style>
/* MOBILE SIZE */
@media screen and (max-width: 768px){
    .carousel-item{
        min-height: 440px;
    }
}

/* TABLET SIZE AND UP */
@media screen and (min-width: 769px){
    .carousel-item{
        min-height: 192px;
    }
}
</style>